import { apiRequest } from '../../api-client';
import { type AccessTypes } from '../billing-client/enterprises/enterprise-members-v2';

export interface SubscriptionMember {
  keycloak_id: string;
  access_type: AccessTypes;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  // Optional to tolerate an older billing runtime that omits it (rolling deploy / lagging on-prem).
  entitlements?: Record<string, boolean>;
}

export interface ProductUserListResult {
  users: SubscriptionMember[];
  subscriptionId: string;
}

interface GetEnterpriseProductUsersParams {
  token: string;
  enterpriseId: string;
  subscriptionId: string;
}

/**
 * Fetches the members of a specific enterprise subscription.
 *
 * GET /api/billing/v2/enterprises/:enterpriseId/subscriptions/:subscriptionId/members
 */
export async function getEnterpriseProductUsers({
  token,
  enterpriseId,
  subscriptionId
}: GetEnterpriseProductUsersParams): Promise<ProductUserListResult> {
  const members = await apiRequest<SubscriptionMember[]>({
    method: 'GET',
    endpoint: `/api/billing/v2/enterprises/${enterpriseId}/subscriptions/${subscriptionId}/members`,
    token
  });

  const memberList = Array.isArray(members) ? members : [];
  return {
    users: memberList,
    subscriptionId
  };
}
